import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginChallengeDataService } from './login-challenge-data.service';

@Injectable()
export class AuthGuard  {

  constructor(private loginChallengeDataService: LoginChallengeDataService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const {queryParams} = route;
    if (queryParams.login_challenge || this.loginChallenge) {
      return true;
    }
    return false;
  }

  private get loginChallenge(): string {
    return this.loginChallengeDataService.getLoginChallenge();
  }
}
